import classNames from 'classnames';
import { composeRenderProps } from 'react-aria-components/composeRenderProps';
import { SelectionIndicator } from 'react-aria-components/SelectionIndicator';
import { ToggleButton } from 'react-aria-components/ToggleButton';
import {
  ToggleButtonGroup as ReactAriaToggleButtonGroup,
  ToggleButtonGroupProps as ReactAriaToggleButtonGroupProps,
  ToggleButtonProps as ReactAriaToggleButtonProps,
} from 'react-aria-components/ToggleButtonGroup';

import css from './ToggleButtonGroup.css';

interface ToggleButtonGroupProps extends Pick<ReactAriaToggleButtonGroupProps, 'aria-describedby' | 'aria-label'> {
  children: React.ReactNode;
  selectedItemId: string;
  onSelectionChange: (selectedItemId: string) => void;
  className?: string;
  size?: 'small' | 'medium';
}

export function ToggleButtonGroup({
  className,
  onSelectionChange,
  selectedItemId,
  size = 'medium',
  ...props
}: ToggleButtonGroupProps) {
  return (
    <ReactAriaToggleButtonGroup
      className={classNames(css.root, { [css.small]: size === 'small', [css.medium]: size === 'medium' }, className)}
      selectionMode="single"
      disallowEmptySelection
      selectedKeys={[selectedItemId]}
      onSelectionChange={(keys) => {
        const [key] = keys;
        onSelectionChange(typeof key === 'string' ? key : key.toString());
      }}
      {...props}
    />
  );
}

interface ToggleButtonGroupItemProps extends Pick<ReactAriaToggleButtonProps, 'id'> {
  children: React.ReactNode;
}

export function ToggleButtonGroupItem(props: ToggleButtonGroupItemProps) {
  return (
    <ToggleButton {...props} className={css.item}>
      {composeRenderProps(props.children, (children) => (
        <>
          <SelectionIndicator className={css.indicator} />
          {children}
        </>
      ))}
    </ToggleButton>
  );
}
